const contexts = []
const views = {}

export function createView (view) {
  // view is string in format module.presenter.action
  if (!(view in views)) { // concrete view does not exists
    const viewArr = view.split('.')
    let viewFound = false

    do {
      viewArr.pop()
      if (viewArr.join('.') in views) {
        view = viewArr.join('.')
        viewFound = true
        break
      }
      
    } while (viewArr.length > 1)

    if (!viewFound && (viewArr[0] + '.default' in views)) { // default module view
      view = viewArr[0] + '.default'
      viewFound = true
    }

    if (!viewFound) { // use default view
      view = 'default'
    }
  }

  const viewExport = contexts[views[view][1]](views[view][0])
  return viewExport.default || viewExport
}

export default function useContext (requireContext) {
  const viewsFiles = requireContext.keys();
  const contextKey = contexts.push(requireContext) - 1

  return viewsFiles.map(filePath => {
    const viewName = filePath.split('/').pop().replace(/\.js$/, '')
    views[viewName] = [filePath, contextKey]
  })
}

useContext(require.context(
  // root folder for components
  './',
  // recursive
  true,
  // include all .js wo index.js
  /\/(?!index\.js$)(?:[^.]+)\.js$/,
))